(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 54722:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(85323);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47741);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35656);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




function AuthSocialLogin() {
    // use i18n
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "auth"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                mb: 3,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                    as: "a",
                    colorScheme: "facebook",
                    width: "100%",
                    href: "".concat("https://api.lamptan.co.th", "/v1/auth/facebook"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .Ug, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Center */ .M5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/image-icon/login-fb.png",
                                    alt: "facebook",
                                    width: 22,
                                    height: 22,
                                    quality: 100
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                                children: t("auth.form.social.loginWithFacebook", {
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                    as: "a",
                    variant: "outline",
                    colorScheme: "gray",
                    border: "1px solid",
                    borderColor: "gray.200",
                    width: "100%",
                    _hover: {
                        bg: "gray.50"
                    },
                    href: "".concat("https://api.lamptan.co.th", "/v1/auth/google"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .Ug, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Center */ .M5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/image-icon/login-google.png",
                                    alt: "google",
                                    width: 24,
                                    height: 24,
                                    quality: 100
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                                children: t("auth.form.social.loginWithGoogle", {
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AuthSocialLogin);


/***/ }),

/***/ 85323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ register; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckCircleFilled.js
var CheckCircleFilled = __webpack_require__(50675);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js
var notification = __webpack_require__(26855);
// EXTERNAL MODULE: ./components/inputs/InputTextGroup.tsx + 2 modules
var InputTextGroup = __webpack_require__(80929);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(35656);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./components/auth/AuthSocialLogin.tsx
var AuthSocialLogin = __webpack_require__(97817);
;// CONCATENATED MODULE: ./components/auth/AuthRegisterForm.tsx






function AuthRegisterForm(param) {
    let { loading , onSubmit  } = param;
    // use i18n
    const { t  } = (0,esm/* useTranslation */.$G)([
        "auth",
        "common"
    ]);
    // use react-hook-form
    const { control , watch , handleSubmit  } = (0,react_hook_form_dist_index_esm/* useForm */.cI)({
        mode: "onBlur"
    });
    // watch confirm new password
    const watchPassword = watch("password", "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            onSubmit: handleSubmit(onSubmit),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTextGroup/* default */.Z, {
                            name: "firstName",
                            label: t("form.label.firstName", {
                                // TH: ชื่อ
                                // EN: First name
                                ns: "common"
                            }),
                            control: control,
                            rules: {
                                required: {
                                    value: true,
                                    message: t("form.message.required", {
                                        ns: "common"
                                    })
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTextGroup/* default */.Z, {
                            name: "lastName",
                            label: t("form.label.lastName", {
                                // TH: นามสกุล
                                // EN: Last name
                                ns: "common"
                            }),
                            control: control,
                            rules: {
                                required: {
                                    value: true,
                                    message: t("form.message.required", {
                                        ns: "common"
                                    })
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTextGroup/* default */.Z, {
                            name: "email",
                            label: t("form.label.email", {
                                // TH: อีเมล
                                // EN: Email
                                ns: "common"
                            }),
                            control: control,
                            rules: {
                                required: {
                                    value: true,
                                    message: t("form.message.required", {
                                        ns: "common"
                                    })
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTextGroup/* default */.Z, {
                            name: "mobileNumber",
                            label: t("form.label.mobileNumber", {
                                // TH: เบอร์โทรศัพท์
                                // EN: Mobile number
                                ns: "common"
                            }),
                            control: control,
                            type: "tel",
                            rules: {
                                required: {
                                    value: true,
                                    message: t("form.message.required", {
                                        ns: "common"
                                    })
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTextGroup/* default */.Z, {
                            name: "password",
                            type: "password",
                            label: t("form.label.password", {
                                ns: "common"
                            }),
                            control: control,
                            rules: {
                                required: {
                                    value: true,
                                    message: t("form.message.required", {
                                        ns: "common"
                                    })
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputTextGroup/* default */.Z, {
                            name: "confirmPassword",
                            type: "password",
                            label: t("form.label.confirmPassword", {
                                ns: "common"
                            }),
                            control: control,
                            rules: {
                                required: {
                                    value: true,
                                    message: t("form.message.required", {
                                        ns: "common"
                                    })
                                },
                                validate: (value)=>value === watchPassword || t("form.message.passwordNotMatch", {
                                        ns: "common"
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                            fontSize: "sm",
                            mb: 2,
                            children: t("auth.register.agreement")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            type: "submit",
                            bg: "black",
                            width: "100%",
                            isLoading: loading,
                            children: t("auth.register.button", {
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                        children: t("auth.form.social.divider")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthSocialLogin/* default */.Z, {})
                ]
            })
        })
    });
}
/* harmony default export */ var auth_AuthRegisterForm = (AuthRegisterForm);

// EXTERNAL MODULE: ./components/page-header/PageHeader.tsx + 1 modules
var PageHeader = __webpack_require__(64070);
// EXTERNAL MODULE: ./components/page-header/PageTitleMobile.tsx
var PageTitleMobile = __webpack_require__(61053);
// EXTERNAL MODULE: ./hooks/useCatchError.ts
var useCatchError = __webpack_require__(65633);
// EXTERNAL MODULE: ./layouts/RootLayout.tsx + 10 modules
var RootLayout = __webpack_require__(89806);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./respository/auth.repository.ts
var auth_repository = __webpack_require__(71219);
;// CONCATENATED MODULE: ./pages/register.tsx














const RegisterPage = ()=>{
    // use i18n
    const { t  } = (0,esm/* useTranslation */.$G)([
        "auth"
    ]);
    // use notification
    const [api, contextHolder] = notification/* default.useNotification */.Z.useNotification();
    const [isMobile] = (0,index_esm/* useMediaQuery */.ac)("(max-width: 767px)");
    const [isDesktop] = (0,index_esm/* useMediaQuery */.ac)("(min-width: 1024px)");
    // use catch error
    const catchError = (0,useCatchError/* default */.Z)();
    // init isSubmitting state
    const [isSubmitting, setIsSubmitting] = (0,react.useState)(false);
    // init is register complete state
    const [isRegisterComplete, setIsRegisterComplete] = (0,react.useState)(false);
    // handle submit
    const handleSubmit = async (values)=>{
        try {
            setIsSubmitting(true);
            // remove confirm password
            delete values.confirmPassword;
            await auth_repository/* AuthRepository.userRegister */.O.userRegister(values);
            setIsRegisterComplete(true);
            api.success({
                message: t("auth.register.complete.title", {
                }),
                description: t("auth.register.complete.goToLogin", {
                })
            });
        } catch (error) {
            catchError(error);
        } finally{
            setIsSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            contextHolder,
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: t("auth.register.title", {
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                        title: t("auth.register.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitleMobile/* default */.Z, {
                        children: t("auth.login.welcomeTitle")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Container */.W2, {
                        children: [
                            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                as: "h2",
                                fontSize: "22px",
                                fontWeight: 400,
                                mt: 10,
                                mb: 6,
                                children: t("auth.register.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                                pt: {
                                    base: 4,
                                    md: 0
                                },
                                pb: {
                                    base: 8,
                                    md: 14
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                    width: "450px",
                                    children: isRegisterComplete ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Center */.M5, {
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                fontSize: "6xl",
                                                color: "green",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleFilled/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                                fontSize: "2xl",
                                                mb: 2,
                                                children: t("auth.register.complete.title", {
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                mb: 4,
                                                textAlign: "center",
                                                children: t("auth.register.complete.goToLogin", {
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/login",
                                                passHref: true,
                                                legacyBehavior: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                    as: "a",
                                                    bg: "gray.800",
                                                    minW: "160px",
                                                    children: t("auth.login.title")
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                mt: {
                                                    base: 0,
                                                    md: 10,
                                                    lg: 0
                                                },
                                                mb: 4,
                                                alignItems: "flex-end",
                                                justifyContent: "space-between",
                                                display: {
                                                    base: "none",
                                                    md: "flex"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                                        as: "h2",
                                                        fontSize: "2xl",
                                                        fontWeight: 400,
                                                        children: t("auth.register.wellcomeTitle", {
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                                        children: [
                                                            t("auth.register.haveAnAccount", {
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/login",
                                                                passHref: true,
                                                                legacyBehavior: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                    variant: "link",
                                                                    as: "a",
                                                                    children: t("auth.login.title")
                                                                })
                                                            }),
                                                            " ",
                                                            t("auth.register.haveAnAccountHere", {
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_AuthRegisterForm, {
                                                    onSubmit: handleSubmit,
                                                    loading: isSubmitting
                                                })
                                            }),
                                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                height: "1px",
                                                my: 6,
                                                bg: "gray.100"
                                            }),
                                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                                                height: "100%",
                                                bg: "#EADECE",
                                                p: !isDesktop ? 6 : 0,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                                    textAlign: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                                            as: "h2",
                                                            mb: 4,
                                                            children: t("auth.register.haveAnAccount")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/login",
                                                            passHref: true,
                                                            legacyBehavior: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                as: "a",
                                                                bg: "gray.800",
                                                                minWidth: "150px",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                            color: "primary.500",
                                                                            children: t("auth.login.title")
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                            children: t("auth.register.haveAnAccountHere")
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
RegisterPage.getLayout = (page)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RootLayout/* default */.Z, {
        children: page
    });
var __N_SSP = true;
/* harmony default export */ var register = (RegisterPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8641,5675,1664,3863,4645,5359,2077,5237,9806,2035,9774,2888,179], function() { return __webpack_exec__(54722); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);